var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "rating-distribution" } }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("FilterTool", {
              attrs: {
                isGraphShowing: true,
                "keep-state-on-query-params": true,
              },
              model: {
                value: _vm.filters,
                callback: function ($$v) {
                  _vm.filters = $$v
                },
                expression: "filters",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass:
                  "h-50 d-flex flex-column justify-content-center align-items-center text-align-center",
              },
              [
                _c("a-spin"),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "charts-wrapper" }, [
          _c("div", { staticClass: "sub-header" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("md-icon", [_vm._v("help")]),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.$t("chatbotv2.ratingDistribution")) +
                      "\n                        "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "div",
                {
                  staticClass: "export-button",
                  on: { click: _vm.exportToCsv },
                },
                [
                  _c("md-icon", [_vm._v("system_update_alt")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.exportToCsv")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "export-button",
                  on: { click: _vm.exportToExcel },
                },
                [
                  _c("md-icon", [_vm._v("system_update_alt")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.exportToExcel"))),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          !_vm.isEmpty()
            ? _c("div", { staticClass: "charts-container" }, [
                _c("div", { staticClass: "statistic-box" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("report.totalRatingCount"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.getTotalRateCount())),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistic-box" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("report.averageRating"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.getAvgRate())),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom-card-report" },
                  [
                    _c("h5", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.ratingDistribution"))),
                    ]),
                    _vm._v(" "),
                    _c("PieChart", { attrs: { data: _vm.getOptions() } }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.isEmpty()
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center mt-5" },
              [
                _c("ChartNotFound", {
                  attrs: { title: _vm.$t("message.dataNotFound") },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }